module.exports = __webpack_public_path__ + "img/thumb_13.c4753af5.jpg";